import {registerReactPartial} from '@github-ui/react-core/register-partial'
import {YourSponsorships} from './YourSponsorships'

registerReactPartial('your-sponsorships', {
  Component: YourSponsorships,
})
